import type { WebsocketAiSmartCanvasMakeRealData } from '@freelancer/datastore/core';
import type { AiSmartCanvasMakeRealMessage } from './ai-smart-canvas-make-real.model';

export function transformAiSmartCanvasMakeReal(
  obj: WebsocketAiSmartCanvasMakeRealData,
): AiSmartCanvasMakeRealMessage {
  if (obj.result.length !== 1) {
    throw new Error('AI Make Real result length is not one');
  }

  return {
    id: obj.id,
    returnValue: obj.result[0].message,
    // Everything below this line are placeholders
    developerPrompt: '',
    base64Image: '',
    messages: '',
  };
}
